import { BaseFiltroPagDTO } from "./base-dto";

export class SituacaoClinicaFiltroDTO extends BaseFiltroPagDTO {
    nome: string;
    ativo: Boolean;
}

export class SituacaoClinicaDTO {
    id: number;
    nome: string;
    descricao: string;
    ativo: boolean;
    urlPdf: string;
    nomePdf: string;
}

export class SituacaoClinicaParm {
    id: number;
    nome: string;
    descricao: string;
    ativo: boolean;
    pdfExcluido: boolean;
}